import styled from "styled-components";

import { colorsPalettes, fonts, mixins } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

export const CUSTOM_STYLES = {
    content: {
        height: 184,
        padding: 0,
        width: 550,
    },
};

export const StyledModalTitle = styled.h2`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["500"],
        $family: fonts.$dmSansFontFamily,
        $size: 20,
        $weight: 500,
    })};
    line-height: 24px;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StyledModalSubtitle = styled.div`
    margin-top: 8px;

    span {
        ${mixins.setFont({ $color: colorsPalettes.carbon["400"], $size: 16 })};
        line-height: 20px;
    }
`;

export const StyledModalContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const StyledModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px;
`;

export const StyledModalBody = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;
    padding: 20px 24px 8px;
`;

export const StyledCloseButton = styled(Button)`
    margin-right: 4px;
`;
